import { Box, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { TemplateTag } from '../../types';

// Narrower source-tag column, fixed-width relates-to column, larger tag-name column
const GRID = 'minmax(0, 0.8fr) minmax(0, 0.9fr) minmax(0, 1.3fr)';

export type ForwardedTagRowProps = {
  rawInputName: string;
  tag: TemplateTag;
  theme: ReturnType<typeof useTheme>;
};

export const ForwardedTagRow = ({ rawInputName, tag, theme }: ForwardedTagRowProps) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: GRID,
      gap: 1,
      alignItems: 'start',
      px: 1,
      py: 0.5,
      borderBottom: `1px solid ${theme.palette.divider}`,
      opacity: 0.55,
    }}
  >
    <Stack spacing={0.25} sx={{ minWidth: 0 }}>
      <Typography variant="body2" noWrap title={tag.displayName ?? rawInputName}>
        {tag.displayName || rawInputName}
      </Typography>
      <Typography variant="caption" color="text.secondary" noWrap>
        {rawInputName}
        {tag.dataType ? ` · ${tag.dataType}` : ''}
      </Typography>
    </Stack>

    {/* No "Relates To" pills for forwarded tags */}
    <Box />

    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography variant="body2" color="text.disabled" sx={{ fontStyle: 'italic' }}>
        Not imported
      </Typography>
      <Tooltip
        title="Forwarded tags require hardware configuration on the destination InHand device and must be set up manually after import."
        arrow
      >
        <InfoOutlinedIcon
          sx={{ fontSize: '0.9rem', color: theme.palette.text.secondary, cursor: 'help' }}
        />
      </Tooltip>
    </Stack>
  </Box>
);
